import { ButtonWithIcon } from '@/components/IconButton';
import { AnimatePresence } from 'framer-motion';
import { FC, useMemo, useState } from 'react';
import { MdEvent } from 'react-icons/md';
import { DateUtils } from '../../helpers/dateUtils';
import { Calendar, CalendarProps, isUndecidedDate } from '../Calendar';
import { createPortal } from 'react-dom';

interface Props extends CalendarProps {
    onDateChange: (d: Date | null) => void;
    defaultDate?: Date | null;
    textInput?: string;
    pricesProductId?: string;
}

const CalendarButton: FC<Props> = ({
    onDateChange,
    defaultDate,
    pricesProductId,
    textInput,
    ...props
}) => {
    const [date, setDate] = useState<Date | null>(defaultDate || null);
    const [isCalendarOpen, setCalendarOpen] = useState(false);

    const handleClose = (value: Date | null) => {
        setDate(value);
        setCalendarOpen(() => false);
        onDateChange(value);
    };

    const handleClick = () => {
        setCalendarOpen(true);
    };

    const textDate = useMemo(() => {
        if (date && isUndecidedDate(date)) return 'Ainda não definido';
        if (date) return DateUtils.formatToDayMonth(date);
        return textInput || 'Selecione uma data';
    }, [date, textInput]);

    return (
        <ButtonWithIcon variant={['yellow', 'round']} onClick={handleClick}>
            <MdEvent />
            {textDate}
            {createPortal(
                <AnimatePresence>
                    {isCalendarOpen && (
                        <Calendar
                            pricesProductId={pricesProductId}
                            defaultDate={defaultDate}
                            onClose={v => handleClose(v)}
                            {...props}
                        />
                    )}
                </AnimatePresence>,
                document.getElementById('root')!
            )}
        </ButtonWithIcon>
    );
};

export default CalendarButton;
